import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HttpClientService {
  constructor(private httpClient: HttpClient) { }

  // Normal POST
  public post<T>(
      url: string,
      data: any,
      options?: any
  ): Observable<T>;

  // Upload progress POST
  public post<T>(
      url: string,
      data: any,
      options: {
        observe: 'events';
        reportProgress: true;
      }
  ): Observable<HttpEvent<T>>;

  // Implementation
  public post<T>(
      url: string,
      data: any,
      options: any = {}
  ): Observable<any> {
    return this.httpClient.post<T>(url, data, options);
  }

  public get(url: string, params?: Record<string, any>, options: object = {}): Observable<object> {
    let httpOptions = { ...options };
    if (params) {
      httpOptions = { ...httpOptions, params: new HttpParams({ fromObject: params }) };
    }
    return this.httpClient.get(url, httpOptions);
  }

  public patch(url: string, data: object, options: object = {}): Observable<object> {
    return this.httpClient.patch(url, data, options);
  }

  public delete(url: string, options: object = {}): Observable<object> {
    return this.httpClient.delete(url, options);
  }

  public put<T>(
      url: string,
      data: any,
      options?: any
  ): Observable<T>;

  public put<T>(
      url: string,
      data: any,
      options: {
        observe: 'events';
        reportProgress: true;
      }
  ): Observable<HttpEvent<T>>;


  public put<T>(
      url: string,
      data: any,
      options: any = {}
  ): Observable<any> {
    return this.httpClient.put<T>(
        url,
        data,
        options
    );
  }
}
